var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4362 8.10938H3.72288L11.9307 0.984375C12.0619 0.869531 11.9823 0.65625 11.8088 0.65625H9.7346C9.6432 0.65625 9.55648 0.689062 9.48851 0.747656L0.631476 8.43281C0.550356 8.50313 0.485298 8.59006 0.44071 8.68772C0.396123 8.78537 0.373047 8.89147 0.373047 8.99883C0.373047 9.10618 0.396123 9.21228 0.44071 9.30994C0.485298 9.4076 0.550356 9.49453 0.631476 9.56484L9.54007 17.2969C9.57523 17.3273 9.61741 17.3438 9.66194 17.3438H11.8065C11.9799 17.3438 12.0596 17.1281 11.9284 17.0156L3.72288 9.89062H17.4362C17.5393 9.89062 17.6237 9.80625 17.6237 9.70312V8.29688C17.6237 8.19375 17.5393 8.10938 17.4362 8.10938Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.0d995631ff934f439f9d712d3f946e76.svg";
export { ForwardRef as ReactComponent };